import { BaseProductStateModel } from './../base-product-state.models';
import { BaseProductInterviewData } from '../_base-product-interview-data';
import { BaseProductService } from '../-base-product.service';
import { UserService } from '../../user/user.service';
import { Observable, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';


export class CommunityInterviewData extends BaseProductInterviewData {
    constructor(
        productService: BaseProductService<BaseProductStateModel>,
        userService: UserService
    ) {
        super(productService, userService);
    }

    getNotQualifiedItems(): Observable<string[]> {
        return of([
            'Over Income'
            , 'Over Assets'
        ]);
    }

    generateNotInterestedItems(): Observable<string[]> {
        return of([
            'Already enrolled'
            , 'Member submitted to SSA'
            , 'Privacy concerns'
            , 'Do not solicit'
            , 'No longer Health Plan member'
            , 'Not interested'
            , 'Other'
        ]);
    }

}
